export default __webpack_public_path__ + "static/icon-awtgs-grade-4-260x260-a5dcea2bc2ef88aa7696fdb6318fc353.jpg";